import { FetchCountiesByProvinceIdCommand } from './FetchCountyByProvinceIdCommand'
import { CountyRepository } from '@/Domain/Localization/County'
import { CountyDto } from './CountyDto'
import { ProvinceCode } from '@/Domain/Localization/Province'

export class FetchCountiesByProvinceIdCommandHandler {
  private _repository: CountyRepository

  constructor (repository: CountyRepository) {
    this._repository = repository
  }

  async handle (command: FetchCountiesByProvinceIdCommand): Promise<CountyDto[]> {
    try {
      const provinceId = new ProvinceCode(command.provinceId())
      const counties = await this._repository.byProvinceId(provinceId)
      return counties.map(current => CountyDto.fromCounty(current))
    } catch (error) {
      return Promise.reject(error)
    }
  }
}
